// scss
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/theme.scss'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { registerLocale } from 'react-datepicker'
import { enGB } from 'date-fns/locale'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from '@redux'
import { CustomToaster } from '@common'

// Register locale to set Monday as first day of week
registerLocale('en-GB', enGB)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
            <CustomToaster />
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
